exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.error[data-v-537b6d26],\n.loading[data-v-537b6d26] {\n  display: inline-block;\n}\n.error i[data-v-537b6d26],\n.loading i[data-v-537b6d26] {\n  margin-right: 5px;\n}\n.error[data-v-537b6d26] {\n  font-weight: bold;\n}\n", ""]);

